module.exports = __webpack_public_path__ + "static/media/simon-joe.1a6f9802.png";